// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Thumb_wrapper__3oRzA","thumbs":"Thumb_thumbs__2lQQT","item":"Thumb_item__w0Kr4","remove":"Thumb_remove__3OoSs"};